import 'babel-polyfill'
import objectFitImages from 'object-fit-images'
import '@fancyapps/fancybox'
import 'lightgallery/dist/js/lightgallery-all.min'
import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'
import {tns} from 'tiny-slider/src/tiny-slider'

import './faq'
import './selects'
import './tab'
import './load-more'
import './front-page'
import './header'
import './news'
import './gravity-form'
import './projects-map.js'
import './popup'
import './countdown'
jQuery.fancybox.defaults.animationEffect = 'fade'
jQuery.fancybox.defaults.gash = false
jQuery.fancybox.defaults.buttons = [
    'close'
]

objectFitImages()

jQuery('.content iframe').reframe()

if (jQuery('.intro').hasClass('intro--with-image')) {

}

[].forEach.call(document.querySelectorAll('.home .tiny-slider'), function (el) {
    tns({
        container            : el,
        controls             : false,
        autoplayButtonOutput : false,
        mouseDrag            : true,
        autoplay             : true,
        lazyload             : false,
        arrowKeys            : true,
        autoplayHoverPause   : true,
    });
});
[].forEach.call(document.querySelectorAll('.page-template-resources .tiny-slider'), function (el) {
    tns({
        container            : el,
        controls             : false,
        autoplayButtonOutput : false,
        mouseDrag            : true,
        autoplay             : true,
        lazyload             : false,
        arrowKeys            : true,
        autoplayHoverPause   : true,
    });
});

[].forEach.call(document.querySelectorAll('.page-template-innovation-week .tiny-slider'), function (el) {
    tns({
        container            : el,
        controls             : false,
        autoplayButtonOutput : false,
        mouseDrag            : true,
        autoplay             : true,
        lazyload             : false,
        arrowKeys            : true,
        autoplayHoverPause   : true,
        gutter               : 2,
        edgePadding          : 2,
        items                : 1,
        responsive           : {
            768 : {
                items : 2
            },
            1024 : {
                items : 3
            }
        }
    });
});

var arangeShapes = function(){
    jQuery(".center-svg>svg").each(function(i, svg) {
        //console.log(jQuery(svg).parent().width());

        jQuery(svg).css({
            left: (jQuery(svg).parent().width() - jQuery(svg).width()) / 2,
            opacity:1
        });
    });

    var window_width = jQuery(window).width();

    var eventsHeight = jQuery(".FP-connect-events #events-back-middle");
    var tfgDeclarationHeight = jQuery("#tfg-declaration-back-middle");
    var tfgPageMiddleContent = jQuery("#tfg-page-middle-content, #tfg-content-top-back-middle");

    var tfgMembersMiddleContent = jQuery("#members-back-middle");
    var tfgMembersLoadMore = jQuery(".tfg-content-loadmore");

    var cultivateHeight = jQuery(".FP-cultivate #cultivate-back-middle");
    var booksBackMiddle = jQuery(".page-template-books #books-back-middle");
    var awardsBackMiddle = jQuery(".page-template-awards #awards-back-middle");

    var extraHeightDeclaration = 0;

    if (tfgMembersLoadMore.height() > 0)
        var buttonHeight = tfgMembersLoadMore.height() + 150;
    else
        var buttonHeight = 0;

    eventsHeight.css({
        width: window_width,
        left: - ( window_width - eventsHeight.parent().width())/2,
        height: eventsHeight.parent().height()-420
    });

    cultivateHeight.css({
        width: window_width,
        left: - ( window_width - cultivateHeight.parent().width())/2,
        height: cultivateHeight.parent().height()-538
    });

    booksBackMiddle.css({
        width: window_width,
        left: -( window_width - booksBackMiddle.parent().width())/2,
        height: booksBackMiddle.parent().height()+2
    });

    awardsBackMiddle.css({
        width: window_width,
        left: - ( window_width - awardsBackMiddle.parent().width())/2,
        height: awardsBackMiddle.parent().height()+5
    });

    //for mobile phones this fixes the back piece height; 100 is the top margin tfg-declaration container;
    // if (jQuery(window).width() <= 480)
    //     extraHeightDeclaration = jQuery('.tfg-declaration-legend').height() - 58;

    //tfg-content-top has a min-height of 759; if it grows beyond that, take the value, substract 759 and add it to the declaration height
    if (jQuery('.tfg-content-top').height() > 759)
        extraHeightDeclaration += jQuery('.tfg-content-top').height() - 759;

    let tfgAdjustment = 210;
    if(window_width < 1024){
        tfgAdjustment = 130;
    }
    if(window_width < 800){
        tfgAdjustment = 165;
    }
    tfgDeclarationHeight.css({
        width: window_width,
        left: - ( window_width - tfgDeclarationHeight.parent().width())/2,
        height: tfgDeclarationHeight.parent().height() + tfgAdjustment + extraHeightDeclaration
    });

    tfgPageMiddleContent.css({
        width: window_width,
        left: - ( window_width - tfgPageMiddleContent.parent().width())/2,
    });

    tfgMembersMiddleContent.css({
        width: window_width,
        left: - ( window_width - tfgMembersMiddleContent.parent().width())/2,
        height: tfgMembersMiddleContent.parent().height()+buttonHeight-580
    });
}

jQuery(document).ready(function () {
    //Create legend from declaration headings
    jQuery('.tfg-declaration-content h1').each( function (e) {
        jQuery('.tfg-declaration-legend').append('<a href="#'+ jQuery(this).attr( 'id' ) +'">'+ jQuery(this).html() +'</a>');
    });

    arangeShapes();

    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 500)
            jQuery('.scroll-to-top').show();
        else
            jQuery('.scroll-to-top').hide();
    });

    jQuery('.scroll-to-top').on('click', function () {
        jQuery('html, body').animate({scrollTop: '0px'}, 500);
    });

    //lightGallery( document.getElementById('lightgallery') );

    jQuery('#lightgallery').lightGallery({
        thumbnail    : true,
        animateThumb : false,
        download     : false
    });


    blockFeatured();

    // resources landing, trivia
    let random = Math.floor( (Math.random() * jQuery('.didyouknow .item').length) + 1 )

    jQuery( '.didyouknow .item:nth-child('+random+')' ).show()

});

jQuery( window ).resize(function() {

    arangeShapes();

    blockFeatured();

});

var blockFeatured = function() {
    var featured = jQuery('.block__featured');
    var figureHeight = jQuery('.block__figure').height();

    var height = ( figureHeight - featured.height() ) + 5;

    featured.css( { top: height } ).show();
}
